/* eslint-disable import/no-cycle */
import axiosProvider from '../utils/axios'
import { isBo } from '../utils/CommonMethods'
import { ACCESS_TOKEN } from '../utils/constants'
import { getLocalStorage } from '../utils/localStorage'

export async function postDataService(params, url, success, faillure, signal) {
  try {
    const token = isBo()
      ? getLocalStorage('ACCESS_TOKEN_BO')
      : getLocalStorage(ACCESS_TOKEN)
    const response = await axiosProvider.post(url, params, token, signal)
    success(response.data)
    return response.data
  } catch (error) {
    faillure(error)
    return error
  }
}

export async function getDataService(url, success, faillure, signal) {
  try {
    const token = isBo()
      ? getLocalStorage('ACCESS_TOKEN_BO')
      : getLocalStorage(ACCESS_TOKEN)
    const response = await axiosProvider.get(url, token, signal)
    success(response.data)
    return response.data
  } catch (error) {
    faillure(error)
    return error
  }
}

export async function deleteDataService(url, success, faillure, signal) {
  try {
    const token = isBo()
      ? getLocalStorage('ACCESS_TOKEN_BO')
      : getLocalStorage(ACCESS_TOKEN)
    const response = await axiosProvider.remove(url, token, signal)
    success(response.data)
    return response.data
  } catch (error) {
    faillure(error)
    return error
  }
}

export async function putDataService(params, url, success, faillure, signal) {
  try {
    const token = isBo()
      ? getLocalStorage('ACCESS_TOKEN_BO')
      : getLocalStorage(ACCESS_TOKEN)
    const response = await axiosProvider.put(url, params, token, signal)
    success(response.data)
    return response.data
  } catch (error) {
    faillure(error)
    return error
  }
}

export async function downLoadFile(url, data, success, faillure) {
  try {
    const token = isBo()
      ? getLocalStorage('ACCESS_TOKEN_BO')
      : getLocalStorage(ACCESS_TOKEN)
    const response = await axiosProvider.post(url, data, token, undefined)
    success(response)
  } catch (error) {
    faillure(error)
  }
}

